import { Row, Col } from "react-bootstrap";
import "./SuggestionWidget.css";

const SuggestionWidget = (props: any) => {
  return (
    <>
      <Row className={`tag-fitprenda-suggestion ${props.styleClass || ""}`}>
        <Col xs={2} xxl={2} className="py-3">
          <img
            src={"/img/icon-suggestion.png"}
            alt={"Suggestion Logo"}
            width={47.9}
            height={47}
          />
        </Col>
        <Col className="py-3 px-4">
          <p className="tag-fitprenda-suggestion-title-font">
            {props.title || "Sugerencia"}
          </p>
          {props.description && (
            <p className="tag-fitprenda-suggestion-content-font">
              {props.description}
            </p>
          )}
        </Col>
      </Row>
    </>
  );
};

export default SuggestionWidget;
